import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { StorageService } from '../services/storage.service';
import { getIcon, openConsent } from 'src/helpers';
import { getActiveStageName } from 'src/helpers';
import {
  createSourceObject,
  Source,
} from '@jaimo-solutions-gmbh/platform-services-module';
import { SourcesTooltipComponent } from '../tooltips/sources-tooltip/sources-tooltip.component';
import { Platform } from '@jaimo-solutions-gmbh/platform-services-module/lib/platforms';
import { getSources } from '../api/account';

@Component({
  selector: 'app-sources',
  templateUrl: './sources.component.html',
  styleUrls: ['./sources.component.scss'],
})
export class SourcesComponent implements OnInit {
  SourcesTooltip = SourcesTooltipComponent;

  sources: Source[] = [];
  isLoading: boolean = true;
  activeStageName: string = getActiveStageName();
  showAll: boolean = false;

  constructor(
    private storageService: StorageService,
    private modalCtrl: ModalController
  ) {}

  ngOnInit() {
    this.getSources();
  }

  getSources = async () => {
    if (!this.activeStageName) return;

    this.isLoading = true;
    const stored = this.storageService.getStored(
      'sources',
      this.activeStageName
    );

    if (stored) {
      this.sources = stored as Source[];
      this.isLoading = false;
    } else {
      const result = await getSources(this.activeStageName);
      this.sources = result.map(createSourceObject);
      this.storageService.saveSource(this.activeStageName, this.sources);
      this.isLoading = false;
    }
  };

  openConsent(url: string, platform: Platform) {
    openConsent(url, platform, this.modalCtrl);
  }

  getIcon = (platform: Platform) => getIcon(platform);
}
